// extracted by mini-css-extract-plugin
module.exports = {"info":"DeductionType_info_1LVVZ"};